import { useEffect } from 'react';
import { useState } from 'react';
import { Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import CardWrapper from '../../components/general/CardWrapper';
import API from '../../services/api';
import { Form } from 'react-bootstrap';
import './Company.css';

function CompanyList() {
  const [companies, setCompanies] = useState([]);
  const [companiesAll, setCompaniesAll] = useState([]);
  const [searchCompanies, setSearchCompanies] = useState(null);
  const [fixeTableHead, setFixeTableHead] = useState(null);

  const tbodyTh = ['', 'Назва компанії', 'ЄДРПОУ'];
  const [selectedStatus, setStatus] = useState(0);

  useEffect(() => {
    async function fetchData() {
      const result = await API.get('admin/company');
      setCompaniesAll(result.data);
      setCompanies(result.data);
    }

    window.addEventListener("scroll", function (ev) {
        handleScroll(ev);
    }, false);
    
    fetchData();
  }, []);

  const handleSubmitSearch = () => {
    if(selectedStatus == 1){
      setCompanies(companiesAll.filter(word => word.name.toLowerCase().includes(searchCompanies.toLowerCase())));
    }else
    if(selectedStatus == 2){
      setCompanies(companiesAll.filter(word => word.edrpou.includes(searchCompanies)));
    }else
      setCompanies(companiesAll.filter(word => word.name.includes(searchCompanies) || word.edrpou.includes(searchCompanies)));
  };

  const handleScroll= (event) =>{
    var scrolled = document.scrollingElement.scrollTop;
    if(scrolled>100){
        setFixeTableHead(true);
      }else{
        setFixeTableHead(false);
      }
  };

  const showTableHead = () => {
    if(fixeTableHead){
      return (
        <div className="page-item-header-fixed">
          <Container>
          <div className="bg-white ">
            <Form.Group className='form-group-bar fixedNavStyle'>
              <Link className="btn-light-theme m-2 addBtnCompanyStyle" to="/admin/company">
                Додати компанію
              </Link>
              <Form.Control id="filterComp" as="select" value={selectedStatus} onChange={(e) => setStatus(e.target.value)}>
                {tbodyTh.map((s, index) => (
                  <option key={index} value={index} className='optionsStyle'>
                    {s}
                  </option>
                ))}
              </Form.Control>
              <div className='searchWrapperStyle'>
                <Form.Control
                  type="search"
                  placeholder="Пошук"
                  className="searchCompanyInput form-group-bar-search searchStyle"
                  aria-label="Search"
                  onChange={(e) => setSearchCompanies(e.target.value)}
                  />
                <button variant="outline-success" 
                  className="me-2 form-group-bar-search-button border-left-0 border"
                    onClick={handleSubmitSearch}></button>
                    </div>
            </Form.Group>
            <CardWrapper theme="light" title="Список компаній">
              <Table bordered className="request-item-header">
                <thead className="bg-light border-right-left-bottom-0">
                  <tr>
                    <th className="page-company-list-number">№</th>
                    <th className='company-name'>Назва компанії</th>
                    <th className="page-company-list-edr">ЄДРПОУ</th>
                    <th className="page-company-list-view"></th>
                  </tr>
                </thead>
              </Table>
            </CardWrapper>
          </div> 
          </Container> 
        </div>  
      );
    }
    }

  return (
    <div className='CompanyWrapperStyle'>
    {showTableHead()}
      <Form.Group className='form-group-bar fixedNavStyle'>
          <Link className="btn-light-theme m-2 addBtnCompanyStyle" to="/admin/company">
            Додати компанію
          </Link>
          <Form.Control id="filterComp" as="select" value={selectedStatus} onChange={(e) => setStatus(e.target.value)}>
            {tbodyTh.map((s, index) => (
              <option key={index} value={index}>
                {s}
              </option>
            ))}
          </Form.Control>
              <div className='searchWrapperStyle'>
            <Form.Control
              type="search"
              placeholder="Пошук"
              className="searchCompanyInput form-group-bar-search"
              aria-label="Search"
              onChange={(e) => setSearchCompanies(e.target.value)}
              />
            <button variant="outline-success" 
              className="me-2 form-group-bar-search-button border-left-0 border"
              onClick={handleSubmitSearch}></button>
              </div>
      </Form.Group>

    <CardWrapper theme="light" title="Список компаній">
      <Table bordered className="request-item-header">
        <thead className="bg-light border-right-left-bottom-0">
          <tr>
            <th className="page-company-list-number">№</th>
            <th className='company-name'>Назва компанії</th>
            <th className="page-company-list-edr">ЄДРПОУ</th>
            <th className="page-company-list-view"></th>
          </tr>
        </thead>
        <tbody>
          {companies.map((c) => (
            <tr key={c.companyId}>
              <td className='text-center'>{c.companyId}</td>
              <td>{c.name}</td>
              <td className='text-center'>{c.edrpou}</td>
              <td className='text-center btn-record-view-edit'>
                <Link to={`/admin/company/edit/${c.companyId}`} className="btn btn-sm btn-warning-edit">
                  {/* Редагувати */}
                </Link>
                <Link to={`/admin/company/${c.companyId}`} className="btn btn-sm btn-primary-look ml-1">
                  {/* Переглянути */}
                </Link>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </CardWrapper>
    </div>
  );
}

export default CompanyList;
